import React from 'react';
import { useIntl } from 'react-intl';
import { ModalFooter } from 'reactstrap';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { CatalogItem } from '../../../../redux/api/fymAPI.types';
import { claimWayMessages } from './claimWayMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Catalog.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ClaimConfirmFooterProps {
  isMerge: boolean;
  /** The row of the merge way, once the artist picked it. */
  mergeTarget: CatalogItem | undefined;
  isClaiming: boolean;
  onBack: () => void;
  onConfirm: () => void;
}

/** The buttons of the claim step: "This is mine", or "Merge into <song>" (design catalog-merge c2). */
const ClaimConfirmFooterComponent: React.FC<ClaimConfirmFooterProps> = ({
  isMerge,
  mergeTarget,
  isClaiming,
  onBack,
  onConfirm,
}) => {
  const intl = useIntl();
  return (
    <ModalFooter>
      <p className={styles.sheetNote}>
        {mergeTarget === undefined
          ? intl.formatMessage({
              id: 'app.sml.catalog.claim.undo',
              defaultMessage: 'You can un-claim any release later from its row.',
            })
          : intl.formatMessage(claimWayMessages.keepsNote, { title: mergeTarget.title })}
      </p>
      <SMLButton outline onClick={onBack} disabled={isClaiming}>
        {intl.formatMessage({ id: 'app.buttons.back', defaultMessage: 'Back' })}
      </SMLButton>
      {isMerge ? (
        <SMLButton color="primary" onClick={onConfirm} disabled={isClaiming || mergeTarget === undefined}>
          {mergeTarget === undefined
            ? intl.formatMessage(claimWayMessages.pickFirst)
            : intl.formatMessage(claimWayMessages.mergeInto, { title: mergeTarget.title })}
        </SMLButton>
      ) : (
        <SMLButton color="primary" onClick={onConfirm} disabled={isClaiming}>
          {intl.formatMessage({ id: 'app.sml.catalog.claim.confirm', defaultMessage: 'This is mine' })}
        </SMLButton>
      )}
    </ModalFooter>
  );
};

export const ClaimConfirmFooter = TypedMemo(ClaimConfirmFooterComponent);
